<!-- <ion-header>
    <div class="header-container">
        <ion-row>
            <ion-col>
                <div class="header-first-row">
                    <div class="header-group">
                       
                    </div>
                    <div>
                        <button ion-button icon-only clear (click)="onConfigureModal()">
                            <ion-icon name="settings"></ion-icon>
                        </button>
                    </div>
                </div>
            </ion-col>
        </ion-row>
    </div>
</ion-header> -->
<ion-content>
    <ion-row>
        <ion-col>
            <div class="header-second-row">
                <ion-select [(ngModel)]="events[0]" (ionChange)="eventNameChange($event)"
                    placeholder="{{eventNames[0]}}" class="header-select" multiple="false">
                    <ion-option *ngFor="let event of events; let i = index" [value]="event"
                        [selected]="getActiveIndex(i)">{{ event.date | transDate: pipeDateFormat }} -
                        {{event.enaOrig}}-{{event.streckeconv}} - {{ event.cid | categoryName | async | translate }}
                    </ion-option>
                </ion-select>
                <!-- <ion-select (ionChange)="eventNameChange($event)" placeholder="{{eventNames[0]}}" class="header-select" multiple="false">
                 <ion-option *ngFor="let event of events" [value]="event">{{ event.date | transDate: 'dd.MM.yyyy' }} - {{event.enaOrig}}-{{event.streckeconv}} - {{ event.cid | categoryName | async | translate }}</ion-option>
             </ion-select> -->
            </div>
        </ion-col>
    </ion-row>
    <!-- <ion-row class="athletes-list" *ngFor="let athlete of bibNumbersArray">
        <ion-col class="athlete" >
            <h1>{{athlete.bibNo}}</h1> <h1>{{athlete.firstName}}</h1> <h1>{{athlete.lastName}}</h1>
        </ion-col>
        <hr>
    </ion-row> -->
    <ion-list class="result-list">
        <result-ranglist-list-item *ngFor="let result of results" [editPageIsOpen]="editPageIsOpen" [result]="result"
            [userSection]="userSection" (click)="click(result)">
        </result-ranglist-list-item>
    </ion-list>
    <ion-fab right bottom>
        <button ion-fab color="primary" (click)="openAddAthletePage()">
            <ion-icon name="add"></ion-icon>
        </button>
    </ion-fab>
</ion-content>